import { put } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';

type AddAction = {
  payload: {
    content: string,
    variant: 'success' | 'error',
  }
};

export function* addNotification(action: AddAction): Generator<any, void, empty> {
  try {
    yield put({
      type: ActionTypes.notifications.add.SUCCESS,
      payload: action?.payload,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.notifications.remove,
    });
  }
}
